import React, { useEffect, useState } from "react";
import axios from "axios";
import GenderDonut from "../../components/admin/GenderDonut";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// -------------------------------------------------------------
// Dashboard
// -------------------------------------------------------------
function DashboardTab() {
  const [stats, setStats] = useState(null);
  const [genderBreakdown, setGenderBreakdown] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/stats`).then((r) => setStats(r.data)).catch(() => {});
    axios
      .get(`${API}/admin/gender-breakdown`)
      .then((r) => setGenderBreakdown(r.data))
      .catch(() => {});
  }, []);
  const cards = [
    { key: "customers", label: "Total Customers" },
    { key: "register", label: "Registrations" },
    { key: "login", label: "Logins" },
    { key: "design_view", label: "Design Views" },
    { key: "wishlist_add", label: "Wishlist Adds" },
    { key: "whatsapp_click", label: "WhatsApp Clicks" },
    { key: "custom_designs", label: "Custom Designs" },
    { key: "custom_subcategories", label: "Custom Sub-cats" },
  ];
  return (
    <div>
      <h1 className="admin-h1">Dashboard</h1>
      <p className="admin-sub">Live snapshot of everything happening on your website.</p>
      <div className="admin-stats">
        {cards.map((c) => (
          <div className="admin-stat" key={c.key}>
            <span className="admin-stat-val">{stats ? stats[c.key] || 0 : "—"}</span>
            <span className="admin-stat-lbl">{c.label}</span>
          </div>
        ))}
      </div>

      <div className="admin-charts" data-testid="admin-charts">
        <GenderDonut
          title="Your Catalog · by Gender"
          data={genderBreakdown?.catalog}
          testId="chart-catalog"
        />
        <GenderDonut
          title="Shopper Interest · by Gender"
          data={genderBreakdown?.interest}
          testId="chart-interest"
        />
      </div>
      <p className="admin-muted" style={{ marginTop: 8, fontSize: 12 }}>
        <em>
          Shopper interest combines wishlist adds and WhatsApp enquiries — use it to plan your next collection.
        </em>
      </p>
    </div>
  );
}

export default DashboardTab;
